import React, { Fragment, useState } from 'react';
import { number, func, string } from 'prop-types';
import { connect } from 'react-redux';
import SurveyNameForm from '../SurveyNameForm';
import QuestionsBox from './QuestionsBox';
import {
  getIESurveyMetaData,
  handleCreateSurvey,
} from '../../../actions/turnkeyOmnibusActions';

const Questions = ({
  handleBack,
  handleNext,
  gizmoSurveyId,
  surveyName,
  getIESurveyMetaData,
  oldSurveyName,
  handleCreateSurvey,
}) => {
  const [isLoading, setLoading] = useState(false);
  const validate = a => {
    const re = /^[a-zA-Z0-9 ]*$/;
    return re.test(a);
  };

  const _isButtonEnable = () => {
    const isValid = validate(surveyName.trim());
    const isValidGizmoId = gizmoSurveyId !== null || gizmoSurveyId !== 0;
    const isDisaled = surveyName && isValid && isValidGizmoId;
    return !isDisaled;
  };

  const _getMetaData = () => {
    getIESurveyMetaData(gizmoSurveyId).then(res => {
      if (res) {
        handleNext();
      }
    });
  };

  const _hanldeNextclick = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (oldSurveyName !== surveyName) {
        handleCreateSurvey().then(res => {
          if (res) {
            _getMetaData();
          }
        });
      } else {
        _getMetaData();
      }
    }, 10000);
  };

  return (
    <Fragment>
      {isLoading && (
        <div id="nprogress"><div className="bar" style={{ transform: 'translate3d(-0.6%, 0px, 0px)', transition: 'all 200ms ease 0s' }}><div className="peg" /></div><div className="spinner"><div className="spinner-icon" /></div></div>
      )}

      <div className="ie--steps--body ie--questions">
        <SurveyNameForm />
        <QuestionsBox />
      </div>
      <footer className="ie--steps--footer">
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={_hanldeNextclick}
          disabled={_isButtonEnable() || isLoading}
        >
          Save &amp; Continue
        </button>
      </footer>
    </Fragment>
  );
};

Questions.propTypes = {
  handleNext: func.isRequired,
  handleBack: func.isRequired,
  gizmoSurveyId: number.isRequired,
  surveyName: string.isRequired,
  getIESurveyMetaData: func.isRequired,
  handleCreateSurvey: func.isRequired,
  oldSurveyName: string.isRequired,
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyInfo, ieSurvey } = turnkeyOmnibus;
  return {
    gizmoSurveyId: surveyInfo.gizmoSurveyId,
    surveyName: surveyInfo.surveyName,
    oldSurveyName: ieSurvey.data.surveyName,
  };
};

export default connect(
  mapStateToProps,
  { getIESurveyMetaData, handleCreateSurvey }
)(Questions);
